import { useState, useEffect } from 'react';
import { getUniqueColumnValues } from '../get-unique-column-values';

interface UseUniqueColumnValuesParams {
    fileId: number;
    sheetId: number;
    columnName: string | null;
    enabled?: boolean;
}

export const useUniqueColumnValues = ({ fileId, sheetId, columnName, enabled = true }: UseUniqueColumnValuesParams) => {
    const [values, setValues] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!enabled || !fileId || !sheetId || !columnName) {
            setValues([]);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);
        getUniqueColumnValues(fileId, sheetId, columnName)
            .then((uniqueValues) => {
                setValues(uniqueValues);
            })
            .catch((err) => {
                setError(err.message || 'Error loading unique values');
                setValues([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [fileId, sheetId, columnName, enabled]);

    return { values, loading, error };
};
